import React, {Component} from 'react';
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';

class What_if_do extends Component{



    constructor(props){
        super(props);

        this.handleClick= this.handleClick.bind(this);

    }

    handleClick= () =>{
        html2canvas(document.getElementById("printDiv")).then( function (canvas){
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            pdf.addImage(imgData, "PNG", 0, 0);
            pdf.save("downloadedPdf.pdf");

        })
    };

    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'activity', defaultMessage: 'Atividade'});
        const placeholder2 = intl.formatMessage({id: 'what.if', defaultMessage: 'E se?'});
        const placeholder3 = intl.formatMessage({id: 'causes', defaultMessage: 'Causas'});
        const placeholder4 = intl.formatMessage({id: 'damage', defaultMessage: 'Consequências'});
        const placeholder5 = intl.formatMessage({id: 'measures', defaultMessage: 'Medidas'});

        return(
            <Card>
                <Row>
                    <div align={"center"}>
                        <h5><b>What if?</b></h5>
                    </div>

                    <div className={"printDiv"}>
                        <form action={"#"}>

                        <p><FormattedMessage id={"what.if.question1"} defaultMessage={"Insira aqui uma atividade de trabalho."}/></p>
                        <input type={"text"} placeholder={placeholder}/>


                            <p><FormattedMessage id={"what.if.question2"} defaultMessage={"Insira aqui um evento adverso/problema que pode ocorrer ao realizar a atividade."}/></p>
                            <input type={"text"} placeholder={placeholder2}/>

                            <p><FormattedMessage id={"what.if.question3"} defaultMessage={"Insira aqui possíveis causas para esse evento adverso."}/></p>
                            <input type={"text"} placeholder={placeholder3}/>

                            <p><FormattedMessage id={"what.if.question4"} defaultMessage={"Insira aqui possíveis danos ao trabalhador que possam ocorrer."}/></p>
                            <input type={"text"} placeholder={placeholder4}/>

                            <p><FormattedMessage id={"what.if.question5"} defaultMessage={"Insira aqui medidas de correção para evitar o evento adverso e proteger o trabalhador."}/> </p>
                            <input type={"text"} placeholder={placeholder5}/>


                        <Button className={"button"} onclick={this.handleClick}>PDF</Button>



                        </form>

                    </div>



                </Row>
            </Card>
            )
    }

}

export default injectIntl(What_if_do);